import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * PageHeader Component
 * Common page header with back navigation and title
 * Refactored with Tailwind CSS
 * 
 * @component
 * @param {string} title - Page title text
 * @param {string} path - Back navigation path
 */
const PageHeader = ({ title, path }) => {
  return (
    <div className="w-full h-[5.124rem] px-[1.875rem] py-[1.875rem] bg-[#3901FF] text-white flex items-center font-medium text-[0.9rem] leading-[1.188rem] whitespace-nowrap">
      <Link to={path} className="flex items-center">
        <ArrowLeft className="w-5 h-5 mr-2.5 text-white" />
      </Link>
      {title}
    </div>
  );
};

export default PageHeader;
